export const CompetitorPriceSources = ['MPDV', 'INFOPANEL', 'PROPRIA'] as const;

export type ICompetitorPriceSources = (typeof CompetitorPriceSources)[number];

export const CompetitorPriceSourcesDataList: {
  label: string;
  value: ICompetitorPriceSources;
}[] = [
  { label: 'Monitoramento PDV', value: 'MPDV' },
  { label: 'Concorrentes diretos', value: 'INFOPANEL' },
  { label: 'Pesquisa própria', value: 'PROPRIA' },
];

const isCompetitorPriceSource = (source: unknown): source is ICompetitorPriceSources => CompetitorPriceSources.includes(source as ICompetitorPriceSources);

/**
 * Filtros salvos podem trazer origens que saíram do produto (ex.: 'INDIRECT', o antigo
 * "Preço de mercado"). Só as origens ainda existentes seguem para o filtro.
 */
export const removeUnavailableCompetitorPriceSources = (sources?: readonly unknown[] | null): ICompetitorPriceSources[] =>
  (sources || []).filter(isCompetitorPriceSource);
